<template>
  <div class="page-selector container d-flex flex-wrap mb-3">
    <div>
      <div class="text-primary text-center">
        {{t('pagination.results.results')}}
        <span v-html="fn(offset + 1)"></span>
        {{t('pagination.results.to')}}
        <span v-html="fn(offset + rowsInPage)"></span>
        {{t('pagination.results.of')}}
        <span :title="t('result.matching_expressions.pagination.types')"
              v-html="fn(rows)"></span>
        <span>&nbsp;</span>
        <span :title="t('result.matching_expressions.pagination.tokens')"
              v-html="`(${fn(totalElements)})`"></span>
      </div>
      <ncs-pagination-links/>
    </div>
    <ncs-go-to-page class="mx-auto"/>
    <div class="d-flex align-self-end ms-auto mt-3">
      <ncs-download-button/>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useNcsI18n, useApiStore } from 'ncs'

const { t, fn } = useNcsI18n()
const apiStore = useApiStore()

const rows = computed(() =>apiStore.response?.pagination?.rows as number)
const totalElements = computed(() => apiStore.response?.totalElements as number)
const offset = computed(() => apiStore.offset)
const rowsInPage = computed(() => apiStore.rowsInPage)
</script>
